import(/* webpackMode: "eager" */ "/vercel/path0/web/src/app/(site)/profile/[id]/page.tsx");
